import validator from 'validator';

export const isEmail = (text: string) => {
  if (!text || !text.length) {
    return false;
  }

  return validator.isEmail(text);
};
